import {validate} from '../../../lib/schema-validator.js'
import {valueSchema, answerSchema} from './schema.js'

export const DATA_POINT_ID = 'nationality_foreign_migrant_worker_status_2'

export const dataPointDefinition = {
  retracedId: 'nationality_foreign_migrant_worker_status_2',
  name: 'Nationality / Foreign Migrant Worker Status',
  description:
    'Foreign migrant workers are persons who migrate from one country to another with a view to being employed otherwise than on their own account. ',
  meta: {
    slcpMeta: {
      key: 'disc-7--13',
      number: 'WT-DIS-10-13',
      masterType: 'Question',
      versionImported: '1.7.0',
    },
  },
  fieldTypeId: 'SHORT_TEXT',
  type: 'RELATIONAL',
  options: [],
  schema: {
    type: 'object',
    properties: {
      value: {
        type: 'string',
      },
    },
    required: ['value'],
  },
  externalIds: [{id: 'disc-7--13', version: '1.7.0', provider: 'slcp'}],
  sortingId: 26780,
  sectionId: '',
  impactArea: '',
  impactAreaId: '',
}

export const validateSchema = data => {
  try {
    validate({value: data, schema: valueSchema})
    return data
  } catch (error) {
    throw new Error(`DATA_POINT_ID: ${error}`)
  }
}
export const transformAnswer = (answer, {meta}) => {
  try {
    validate({value: answer, schema: answerSchema})
    const formattedDataPointKey = DATA_POINT_ID.replace(/_([a-z])/g, g => g[1].toUpperCase())
    return {[formattedDataPointKey]: answer}
  } catch (error) {
    throw new Error(`DATA_POINT_ID: ${error}`)
  }
}
